/**
 * @flow
 * @relayHash 07022acd2338cbea86e518673611dbd0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SignatureBlockFieldVisibility = "HIDE" | "SHOW" | "%future added value";
export type SignatureTypeEnum = "PAD" | "TYPED" | "%future added value";
export type CreateContractSignatureBlockInput = {
  clientMutationId?: ?string,
  contract_id: string,
  signing_party: string,
  name_visibility: SignatureBlockFieldVisibility,
  name?: ?string,
  email_visibility: SignatureBlockFieldVisibility,
  email?: ?string,
  title_visibility: SignatureBlockFieldVisibility,
  title?: ?string,
  company_name_visibility: SignatureBlockFieldVisibility,
  company_name?: ?string,
  phone_visibility: SignatureBlockFieldVisibility,
  phone?: ?string,
  address_visibility: SignatureBlockFieldVisibility,
  address?: ?string,
  signer_fills_fields: boolean,
};
export type SignatureBlocks_createContractSignatureBlockMutationVariables = {|
  input: CreateContractSignatureBlockInput
|};
export type SignatureBlocks_createContractSignatureBlockMutationResponse = {|
  +createContractSignatureBlock: ?{|
    +new_contract_signature_block_edge: ?{|
      +node: ?{|
        +id: string,
        +address: ?string,
        +address_visibility: ?SignatureBlockFieldVisibility,
        +company_name: ?string,
        +company_name_visibility: ?SignatureBlockFieldVisibility,
        +email: ?string,
        +email_visibility: ?SignatureBlockFieldVisibility,
        +name: ?string,
        +name_visibility: ?SignatureBlockFieldVisibility,
        +phone: ?string,
        +phone_visibility: ?SignatureBlockFieldVisibility,
        +signature_type: ?SignatureTypeEnum,
        +signature_typed_name: ?string,
        +signed_at: ?any,
        +signer_fills_fields: ?boolean,
        +signing_party: ?string,
        +share_token: ?string,
        +title: ?string,
        +title_visibility: ?SignatureBlockFieldVisibility,
      |}
    |}
  |}
|};
export type SignatureBlocks_createContractSignatureBlockMutation = {|
  variables: SignatureBlocks_createContractSignatureBlockMutationVariables,
  response: SignatureBlocks_createContractSignatureBlockMutationResponse,
|};
*/


/*
mutation SignatureBlocks_createContractSignatureBlockMutation(
  $input: CreateContractSignatureBlockInput!
) {
  createContractSignatureBlock(input: $input) {
    new_contract_signature_block_edge {
      node {
        id
        address
        address_visibility
        company_name
        company_name_visibility
        email
        email_visibility
        name
        name_visibility
        phone
        phone_visibility
        signature_type
        signature_typed_name
        signed_at
        signer_fills_fields
        signing_party
        share_token
        title
        title_visibility
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateContractSignatureBlockInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createContractSignatureBlock",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "CreateContractSignatureBlockInput!"
      }
    ],
    "concreteType": "CreateContractSignatureBlockPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "new_contract_signature_block_edge",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractSignatureBlockEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractSignatureBlock",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "phone",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "address_visibility",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "company_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "company_name_visibility",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "email_visibility",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name_visibility",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "address",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "phone_visibility",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "signature_type",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "signature_typed_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "signed_at",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "signer_fills_fields",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "signing_party",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "share_token",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "title_visibility",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "SignatureBlocks_createContractSignatureBlockMutation",
  "id": null,
  "text": "mutation SignatureBlocks_createContractSignatureBlockMutation(\n  $input: CreateContractSignatureBlockInput!\n) {\n  createContractSignatureBlock(input: $input) {\n    new_contract_signature_block_edge {\n      node {\n        id\n        address\n        address_visibility\n        company_name\n        company_name_visibility\n        email\n        email_visibility\n        name\n        name_visibility\n        phone\n        phone_visibility\n        signature_type\n        signature_typed_name\n        signed_at\n        signer_fills_fields\n        signing_party\n        share_token\n        title\n        title_visibility\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SignatureBlocks_createContractSignatureBlockMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "SignatureBlocks_createContractSignatureBlockMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f5a05b0c4c61675e884ad4b4f3ad4a4a';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Contract/__generated__/SignatureBlocks_createContractSignatureBlockMutation.graphql.js